import React from "react";
import "./App.scss";
import Main from "./containers/Main";

// library.add(fab, faCheckSquare, faCoffee);

function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
